import { useLocation, useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  Col,
  Empty,
  Row,
  Skeleton,
  Tag,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import { getById } from "../../../controllers/entities";
import "./groups.scss";
import { capitalizeString } from "../../../shared/util";
import Moment from "react-moment";
import {
  Contact,
  RequestStatus,
  RecordStatus,
  PageSetting,
  DataItem,
  routerData,
} from "../..";
import { saveRequest, sendNotification } from "../../../controllers/connection";
import { getSended } from "../../../controllers/store/actions/connection/connection-sended-actions";
import useRecomendations from "../../../hooks/recomendations-entities-hook";
import { RequestConnection } from "../../../models/RequestConnection";
import ConnectionRequest from "../../components/Forms/Modal/ConnectionRequest/Connection-Request";
import { useSelector } from "react-redux";
import store from "../../../controllers/store";
import RecomendationList from "../../components/Recomedations";
import { UserOutlined } from "@ant-design/icons";
type NotificationType = "success" | "info" | "warning" | "error";
const dispatch = store.dispatch;

const GroupDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let { params } = location.state;
  const [group, setGroup] = useState({} as any);
  const [page, setPage] = useState(1);
  const { result, getRecomendations } = useRecomendations();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contact, setContact] = useState<Contact>();
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: "UNAB",
      description: "Solicitud enviada correctamente.",
    });
  };

  useEffect(() => {
    const getGroup = async () => {
      const group = await getById(params.id);
      console.log("group", group);
      setGroup(group);
    };

    getRecomendations("all", { filter: "" }, 1, 5);
    getGroup();
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <Skeleton loading={result.loading} active className="full-width">
        <ConnectionRequest
          open={isModalOpen}
          onOk={(value: any, text: string) => {
            const request = new RequestConnection(
              "",
              text,
              user.me,
              {
                name: contact?.name || "",
                email: contact?.email || "",
                organization_name:
                  contact?.organization_name || contact?.name || "",
                type: contact?.type || "",
              },
              RequestStatus.Pending,
              value.requestType || "",
              contact?.type
            );

            saveRequest(request);
            sendNotification(request);
            setIsModalOpen(false);
            openNotificationWithIcon("success");
            dispatch(
              getSended(
                "connection_request",
                {
                  meta: "filter_count",
                  filter: `&filter[user_created][id][_eq]=${user.me.id}&filter[status][_eq]=${RecordStatus.Active}`,
                },
                1,
                10
              )
            );
          }}
          onCancel={() => setIsModalOpen(false)}
          contact={{
            name: contact?.name || "",
            email: contact?.email || "",
            organization_name: contact?.organization_name || "",
            type: contact?.type || "",
          }}
        />
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={8} lg={16}>
            <h1 className="conection-heading-section">Datos Generales</h1>
            <Card
              className="ant-card-conection ant-card-conection-border"
              onClick={() => {}}
              hoverable
              style={{ width: "100%", marginBottom: 30 }}
            >
              <Row gutter={[8, 8]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Nombre del grupo</h2>
                  <p className="conection-value">
                    {capitalizeString(group?.nme_grupo_gr)}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Descripción</h2>
                  <p className="conection-value text-justify">
                    {capitalizeString(group?.description || "Sin descripcion")}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Institución</h2>
                  <p className="conection-value">
                    {capitalizeString(group.INST_AVAL || "No definidos")}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Área general</h2>
                  <p className="conection-value">
                    {capitalizeString(
                      group?.nme_area_gr?.AREA_DE_CONOCIMIENTO
                    ) || ""}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Área especifica</h2>
                  <p className="conection-value">
                    {capitalizeString(
                      group?.nme_area_esp_gr?.ESPECIALIDAD_DE_CONOCIMIENTO || ""
                    )}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">
                    Gran área del conocimiento
                  </h2>
                  <p className="conection-value">
                    {capitalizeString(
                      group?.nme_gran_area_gr?.GRAN_AREA_DE_CONOCIMIENTO || ""
                    )}
                  </p>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">Clasificación del grupo</h2>
                  <Tag
                    color="#F37221"
                    style={{ marginBottom: 10 }}
                    bordered={false}
                  >
                    {capitalizeString(
                      group?.nme_clasificacion_gr || "Sin clasificación"
                    )}
                  </Tag>
                  <p className="conection-value"></p>
                </Col>
                {group.features ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">Caracteristicas</h2>
                    <p className="conection-value">
                      {capitalizeString(
                        group?.features || "Sin caracteristicas"
                      )}
                    </p>
                  </Col>
                ) : null}
                {group.issue_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Fecha de expedición</h2>
                    <p className="conection-value">
                      {group?.issue_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {group?.current_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Vigencia</h2>
                    <p className="conection-value">
                      {group?.current_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {group?.update_date ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Última Actualización</h2>
                    <p className="conection-value">
                      {group?.update_date || "N/A"}
                    </p>
                  </Col>
                ) : null}
                {group?.source ? (
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <h2 className="conection-label">Fuente</h2>
                    <p className="conection-value">{group?.source}</p>
                  </Col>
                ) : null}
                {group?.recognized_min ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">
                      Reconociento Minciencias (Sí/No){" "}
                    </h2>
                    <p className="conection-value">
                      {group?.recognized_min === 1 ? "Si" : "No"}
                    </p>
                  </Col>
                ) : null}
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">URL</h2>
                  {group.URL ? (
                    <Button
                      type="primary"
                      onClick={() => {
                        window.open(group?.URL || "", "_blank");
                      }}
                    >
                      Abrir Enlace
                    </Button>
                  ) : (
                    "No informa"
                  )}
                </Col>
              </Row>
              <Row gutter={[8, 8]} style={{ width: "100%" }}>
                {group?.enlace_cvlac ? (
                  <Col xs={24} sm={12} md={8} lg={12}>
                    <h2 className="conection-label">URL</h2>
                    {group.groups_id.URL ? (
                      <Button
                        type="primary"
                        onClick={() => {
                          window.open(group?.url || "", "_blank");
                        }}
                      >
                        Abrir Enlace
                      </Button>
                    ) : (
                      "No informa"
                    )}
                  </Col>
                ) : null}
              </Row>
            </Card>
            <>
              <h1 className="conection-heading-section">Investigadores</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Row gutter={[8, 8]} className="full-width">
                  <Col xs={24} sm={12} md={8} lg={24}>
                    {!group.searchers || group?.searchers?.length === 0 ? (
                      <Empty description={"0 Registros"} />
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  {group?.searchers?.map((s: any) => (
                    <Col lg={12} key={s.id}>
                      <div
                        onClick={() => {
                          go(
                            {
                              id: s.searchers_id.id,
                              name: s.searchers_id.nombre,
                              type: s.searchers_id.actor_type.actor,
                            },
                            "searchers"
                          );
                        }}
                        style={{ marginBottom: 20 }}
                        className="flex with-pointer"
                      >
                        <Avatar icon={<UserOutlined />} />
                        <p className="profile-info">
                          {`${s?.searchers_id?.nombre}` || ""}
                          <span>
                            {`${s?.searchers_id?.nme_niv_form_pr}` || ""}
                          </span>
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
                <Row />
              </Card>
            </>
            <>
              <h1 className="conection-heading-section">Instituciones</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  <Row gutter={[8, 8]} className="full-width">
                    <Col xs={24} sm={12} md={8} lg={24}>
                      {group && group.universities?.length === 0 ? (
                        <Empty description={"0 Registros"} />
                      ) : null}
                    </Col>
                  </Row>
                  {group && group.universities ? (
                    <div>
                      {group.universities?.map((u: any) => {
                        return (
                          <Col xs={24} sm={12} md={8} lg={12}>
                            <Button
                              className="connection-font"
                              size="middle"
                              onClick={() => {
                                go(
                                  {
                                    id: u.universities_id.id,
                                    name: u.universities_id.institution_name,
                                    type: u.universities_id.actor_type.actor,
                                  },
                                  "universities"
                                );
                              }}
                              style={{
                                marginBottom: 10,
                                marginRight: 20,
                                width: "auto",
                              }}
                            >
                              {capitalizeString(
                                u.universities_id?.institution_name
                              )}
                            </Button>
                          </Col>
                        );
                      })}
                    </div>
                  ) : null}
                </Row>
              </Card>
            </>
            <>
              <h1 className="conection-heading-section">Producto</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Row gutter={[8, 8]} className="full-width">
                  <Col xs={24} sm={12} md={8} lg={24}>
                    {!group?.products || group.products?.length === 0 ? (
                      <Empty description={"0 Registros"} />
                    ) : null}
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  {group?.products?.map((s: any) => (
                    <Col lg={12} key={s.id}>
                      <Button
                        className="connection-font"
                        title={capitalizeString(
                          s?.products_id?.nme_producto_pd
                        )}
                        style={{
                          overflow: "hidden",
                          whiteSpace: "normal",
                          textOverflow: "ellipsis",
                        }}
                        size="middle"
                        onClick={() => {
                          go(
                            {
                              id: s.products_id.id,
                              name: s.products_id.nme_producto_pd,
                              type: s.products_id.capacity_type.capacities,
                            },
                            "products"
                          );
                        }}
                      >
                        {capitalizeString(s?.products_id?.nme_producto_pd)}
                      </Button>
                    </Col>
                  ))}
                </Row>
                <Row />
              </Card>
            </>
          </Col>

          {user?.me ? (
            <Col xs={24} sm={12} md={8} lg={8}>
              <h1 className="conection-heading-section">Sugerencias</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Skeleton
                  loading={result.loading}
                  active
                  className="full-width"
                >
                  <RecomendationList
                    totalPages={result.pagination?.total}
                    onPaginationChanged={(page) => {
                      getRecomendations(
                        "all",
                        { filter: {} },
                        page,
                        PageSetting.limit
                      );
                      setPage(page);
                    }}
                    onConnect={(contact) => {
                      setContact({
                        name: contact.title,
                        type: contact.description,
                        email: contact.contact_email,
                      });
                      setIsModalOpen(!isModalOpen);
                    }}
                    data={result.values
                      .filter((r) => r.id !== params?.id)
                      .map((recomendation: any) => {
                        return {
                          title: recomendation.name,
                          description: `${recomendation.type.actor} - ${
                            recomendation.city || recomendation.cityRaw || ""
                          }`,
                          avatar: "",
                          contact_email: recomendation.contact_email,
                        } as DataItem;
                      })}
                  />
                </Skeleton>
              </Card>
            </Col>
          ) : null}
        </Row>
      </Skeleton>
    </div>
  );
};

export default GroupDetail;
